import * as React from "react";
import BOSideItem from "./BOSideItem/BOSideItem";
import BOSideSubMenu from "./BOSideSubMenu";
import "./BOSideStyle.css";
import { withRouter } from "react-router";

import { groupAuth } from "app/utils/authGroups";

type MenuItem = {
  text: string;
  link: string;
};

export type SideOption = {
  name: string;
  title: string;
  icon: string;
  activeUrl: string;
  authorizedGroups: Array<string>;
  authorizedDataGroups: Array<string>;
  type: string;
  menuItems?: Array<MenuItem>;
  dynamicFile?: string;
};

type State = {
  sideOptions: Array<SideOption>;
  selectedOption: SideOption;
};

type Props = {
  clearStates: () => void;
  history: any;
  location: any;
  match: any;
  staticContext: any;
};

class BOSide extends React.Component<Props, State> {
  state = {
    sideOptions: [
      {
        name: "snapscan_fraud",
        title: "SnapScan Fraud",
        icon: "fa-user-secret",
        activeUrl: "/snapscan/fraud",
        authorizedGroups: ["Fraud/Admin", "Fraud/Staff"],
        authorizedDataGroups: ["Data/SnapScan"],
        type: "static",
        menuItems: [
          {
            text: "Payment Limit Hits",
            link: "/snapscan/fraud/limit_hits",
          },
          {
            text: "Top Merchants",
            link: "/snapscan/fraud/top_merchants",
          },
          {
            text: "Top Devices",
            link: "/snapscan/fraud/top_devices",
          },
          {
            text: "Suspicious Withdrawals",
            link: "/snapscan/fraud/suspicious_withdrawals",
          },
          {
            text: "Suspicious Devices",
            link: "/snapscan/fraud/suspicious_devices",
          },
          {
            text: "Suspicious Card Loads",
            link: "/snapscan/fraud/suspicious_card_loads",
          },
          {
            text: "Merchant Limit Configs",
            link: "/snapscan/fraud/merchant_limit_configs",
          },
          {
            text: "Wallet P2P",
            link: "/snapscan/fraud/wallet_p2p",
          },
          {
            text: "Wallet Spend",
            link: "/snapscan/fraud/wallet_spend",
          },
        ],
      },
      {
        name: "snapscan_ops",
        title: "SnapScan Ops",
        icon: "fa-building",
        activeUrl: "/snapscan/ops",
        authorizedGroups: ["Ops/Admin", "Ops/Staff"],
        authorizedDataGroups: ["Data/SnapScan"],
        type: "static",
        menuItems: [
          {
            text: "Dashboards",
            link: "/snapscan/ops/dashboards",
          },
          {
            text: "Users",
            link: "/snapscan/ops/users",
          },
          {
            text: "Merchants",
            link: "/snapscan/ops/merchants",
          },
          {
            text: "Payments",
            link: "/snapscan/ops/payments",
          },
          {
            text: "Refund Requests",
            link: "/snapscan/ops/refund_requests",
          },
          {
            text: "Card Loads",
            link: "/snapscan/ops/card_loads",
          },
          {
            text: "Card Terminals",
            link: "/snapscan/ops/card_terminals",
          },
          {
            text: "Devices",
            link: "/snapscan/ops/devices",
          },
          {
            text: "SMS",
            link: "/snapscan/ops/sms",
          },
          {
            text: "Electricity",
            link: "/snapscan/ops/electricity",
          },
          {
            text: "User Messaging",
            link: "/snapscan/ops/user_messaging",
          },
          {
            text: "Billers",
            link: "/snapscan/ops/biller_categories",
          },
          {
            text: "Status Messages",
            link: "/snapscan/ops/application_status_messages",
          },
        ],
      },
      {
        name: "snapscan_settlements",
        title: "SnapScan Settlements",
        icon: "fa-file-text",
        activeUrl: "/snapscan/settlements",
        authorizedGroups: ["Settlement/Admin"],
        authorizedDataGroups: ["Data/SnapScan"],
        type: "static",
        menuItems: [
          {
            text: "Summary",
            link: "/snapscan/settlements/summary",
          },
          {
            text: "Settlement batches",
            link: "/snapscan/settlements/batches",
          },
          {
            text: "Bank Settlements",
            link: "/snapscan/settlements/bank_settlements",
          },
          {
            text: "Withdrawal Batches",
            link: "/snapscan/settlements/withdrawals/batches",
          },
        ],
      },
      {
        name: "snapscan_wallet",
        title: "SnapScan Wallets",
        icon: "fa-money",
        activeUrl: "/snapscan/wallets",
        authorizedGroups: ["Wallet/Admin", "Wallet/Staff"],
        authorizedDataGroups: ["Data/SnapScan"],
        type: "static",

        menuItems: [
          {
            text: "Wallets",
            link: "/snapscan/wallets",
          },
          {
            text: "Vouchers",
            link: "/snapscan/vouchers",
          },
          {
            text: "Withdrawals",
            link: "/snapscan/wallet_withdrawals",
          },
        ],
      },
      {
        name: "snapscan_events",
        title: "SnapScan Events",
        icon: "fa-ticket",
        activeUrl: "/snapscan/events",
        authorizedGroups: ["Ops/Admin", "Ops/Staff"],
        authorizedDataGroups: ["Data/SnapScan"],
        type: "static",
        menuItems: [
          {
            text: "All Events",
            link: "/snapscan/events/all",
          },
          {
            text: "Review Queue",
            link: "/snapscan/events/review_queue",
          },
        ],
      },
    ],
    selectedOption: null,
  };

  componentDidMount() {
    this.setState({
      selectedOption: this.state.sideOptions.find((option) =>
        window.location.pathname.includes(option.activeUrl)
      ),
    });
  }

  loadOption = (name: string): void => {
    this.setState({
      selectedOption: this.state.sideOptions.find(
        (option) => option.name === name
      ),
    });
  };

  render() {
    const visibleOptions = this.state.sideOptions.filter(
      (option) =>
        groupAuth.hasAccessGroup(option.authorizedGroups) &&
        groupAuth.hasAllDataGroups(option.authorizedDataGroups)
    );

    const boSideMain = () => {
      return (
        <ul id="BOSideMain">
          {visibleOptions.map((option, index) => {
            return (
              <BOSideItem
                key={index}
                name={option.name}
                icon={option.icon}
                title={option.title}
                active={window.location.pathname.includes(option.activeUrl)}
                onClick={() => this.loadOption(option.name)}
              />
            );
          })}
        </ul>
      );
    };

    return (
      <div id="BOSideContainer">
        {boSideMain()}

        <BOSideSubMenu
          clearStates={this.props.clearStates}
          selectedOption={this.state.selectedOption}
        />
      </div>
    );
  }
}

export default withRouter(BOSide as any);
